import { Component, OnInit, ViewChild } from '@angular/core';

import { SedsModalComponent } from './seds-modal.component';

@Component({
  template: '',
  standalone: false,
})
export abstract class SedsModalAbstractComponent implements OnInit {
  @ViewChild(SedsModalComponent, { static: true })
  modalComponent!: SedsModalComponent;

  public data: any;

  ngOnInit(): void {
    this.data = this.modalComponent.getData() ? this.modalComponent.getData() : {};
  }

  public close(result?: any): void {
    this.modalComponent.close(result);
  }
}
